import React from 'react';

type BadgeVariant = 'foundations' | 'intermediate' | 'advanced' | 'professional' | 'success' | 'warning' | 'danger' | 'info' | 'default' | 'locked';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}

const variantStyles: Record<BadgeVariant, string> = {
  foundations: 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  intermediate: 'bg-blue-100 text-blue-700 border border-blue-200',
  advanced: 'bg-purple-100 text-purple-700 border border-purple-200',
  professional: 'bg-amber-100 text-amber-700 border border-amber-200',
  success: 'bg-green-100 text-green-700 border border-green-200',
  warning: 'bg-amber-100 text-amber-700 border border-amber-200',
  danger: 'bg-red-100 text-red-700 border border-red-200',
  info: 'bg-sky-100 text-sky-700 border border-sky-200',
  default: 'bg-muted text-muted-foreground border border-border',
  locked: 'bg-slate-100 text-slate-500 border border-slate-200',
};

export default function Badge({ variant = 'default', children, className = '', size = 'sm' }: BadgeProps) {
  const sizeStyles = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';
  return (
    <span className={`inline-flex items-center gap-1 font-semibold rounded-full ${sizeStyles} ${variantStyles[variant]} ${className}`}>
      {children}
    </span>
  );
}